import { VCheckbox } from 'vuetify/lib/components/VCheckbox';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCheckbox,{attrs:{"disabled":_vm.disabled,"dense":"","hide-details":"","ripple":false},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('span',{class:_vm.value ? 'primary--text font-weight-bold' : 'black--text',staticStyle:{"font-size":"15px"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])]},proxy:true}]),model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }